var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFavoriteEnable = function SvgIconFavoriteEnable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M12.805 21.896a1.21 1.21 0 0 1-1.606-.003l-.677-.605C5.269 16.602 1.8 13.51 1.8 9.718 1.8 6.628 4.269 4.2 7.41 4.2A6.15 6.15 0 0 1 12 6.297 6.15 6.15 0 0 1 16.59 4.2c3.141 0 5.61 2.428 5.61 5.518 0 3.793-3.468 6.884-8.721 11.579z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFavoriteEnable;